/** Prefill Architecture assistant from the opening-session win beat. */

const PREFILL_KEY = "dp_agent_prefill";

export function stashAgentPrefill({ query, entity } = {}) {
  const q = String(query || "").trim();
  if (!q) return;
  try {
    sessionStorage.setItem(
      PREFILL_KEY,
      JSON.stringify({
        query: q,
        entity: entity && typeof entity === "object" ? entity : null,
      })
    );
  } catch {
    /* ignore */
  }
}

export function consumeAgentPrefill() {
  try {
    const raw = sessionStorage.getItem(PREFILL_KEY);
    sessionStorage.removeItem(PREFILL_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const query = String(parsed?.query || "").trim();
    if (!query) return null;
    return {
      query,
      entity:
        parsed?.entity && typeof parsed.entity === "object" ? parsed.entity : null,
    };
  } catch {
    return null;
  }
}
